// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editstoragefields {
    margin-top: 30px;
    display: grid;
    grid-template-columns: 40%;
    grid-column-gap: 70px;
    grid-row-gap: 20px;
    padding: 10px;
    justify-content: center;
    margin-bottom: 50px;
  }
  
  .editstoragebutton-one {
    background-color: #8b5ccc;
    border: none;
    color: white;
    padding: 5px 30px;
    text-align: center;
    font-size: 20px;
    margin-bottom: 10px;
    border-radius: 5px;
  }
  
  .editstoragebutton-one:hover {
    background-color: rgba(54, 3, 125, 0.919);
    color: white;
  }

  .editstoragebutton-two {
    background-color: #8b5ccc;
    border: none;
    color: white;
    padding: 5px 30px;
    text-align: center;
    font-size: 20px;
    margin-bottom: 10px;
    border-radius: 5px;
  }
  
  .editstoragebutton-two:hover {
    background-color: rgba(54, 3, 125, 0.919);
    color: white;
  }

  .editfirstfield {
    display: grid;
    grid-row-gap: 20px;
    margin-top: 20px;
  }
  
  .editsecondfield {
    display: grid;
    grid-row-gap: 30px;
    margin-top: 30px;
    margin-bottom: 20px;
  }
  
  .label {
    padding: 10px;
  }
  
  .Radiobutton {
    display: flex;
    margin-top: 30px;
    justify-content: center;
  }
  .line {
    display: grid;
    grid-template-columns: 45% 10% 45%;
    margin-top: 30px;
  }

  .editfirstfields{
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .editstoragebtn{
    /* display: grid;
    grid-template-columns:50% 50%; */
  }
  `, "",{"version":3,"sources":["webpack://./src/components/editcomponent/editstorage/editstorage.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,aAAa;IACb,0BAA0B;IAC1B,qBAAqB;IACrB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,yCAAyC;IACzC,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,yCAAyC;IACzC,YAAY;EACd;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,aAAa;IACb,kCAAkC;IAClC,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE;oCACgC;EAClC","sourcesContent":[".editstoragefields {\n    margin-top: 30px;\n    display: grid;\n    grid-template-columns: 40%;\n    grid-column-gap: 70px;\n    grid-row-gap: 20px;\n    padding: 10px;\n    justify-content: center;\n    margin-bottom: 50px;\n  }\n  \n  .editstoragebutton-one {\n    background-color: #8b5ccc;\n    border: none;\n    color: white;\n    padding: 5px 30px;\n    text-align: center;\n    font-size: 20px;\n    margin-bottom: 10px;\n    border-radius: 5px;\n  }\n  \n  .editstoragebutton-one:hover {\n    background-color: rgba(54, 3, 125, 0.919);\n    color: white;\n  }\n\n  .editstoragebutton-two {\n    background-color: #8b5ccc;\n    border: none;\n    color: white;\n    padding: 5px 30px;\n    text-align: center;\n    font-size: 20px;\n    margin-bottom: 10px;\n    border-radius: 5px;\n  }\n  \n  .editstoragebutton-two:hover {\n    background-color: rgba(54, 3, 125, 0.919);\n    color: white;\n  }\n\n  .editfirstfield {\n    display: grid;\n    grid-row-gap: 20px;\n    margin-top: 20px;\n  }\n  \n  .editsecondfield {\n    display: grid;\n    grid-row-gap: 30px;\n    margin-top: 30px;\n    margin-bottom: 20px;\n  }\n  \n  .label {\n    padding: 10px;\n  }\n  \n  .Radiobutton {\n    display: flex;\n    margin-top: 30px;\n    justify-content: center;\n  }\n  .line {\n    display: grid;\n    grid-template-columns: 45% 10% 45%;\n    margin-top: 30px;\n  }\n\n  .editfirstfields{\n    margin-top: 20px;\n    margin-bottom: 20px;\n  }\n\n  .editstoragebtn{\n    /* display: grid;\n    grid-template-columns:50% 50%; */\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
